import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import IcoTransactionsLayer from "../../components/Ico/IcoTransactionsLayer";
import IcoCardLayer from "../../components/Ico/IcoCardLayer";

const IcoManagePage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="ICO Management" />
                    <IcoCardLayer />
                    <IcoTransactionsLayer />
               </MasterLayout>
          </>
     );
};

export default IcoManagePage;
